/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetStationStatusStatusesQueryResponse, SegmentsGetStationStatusStatusesQueryParams, SegmentsGetStationStatusStatuses400, SegmentsGetStationStatusStatuses401, SegmentsGetStationStatusStatuses403 } from "../models/SegmentsGetStationStatusStatuses";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { segmentsGetStationStatusStatuses } from "../axios/segmentsGetStationStatusStatuses";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const segmentsGetStationStatusStatusesQueryKey = (params: SegmentsGetStationStatusStatusesQueryParams = {}) => ["api-v2", { url: '/segments/v1/status' }, ...(params ? [params] : [])] as const

export type SegmentsGetStationStatusStatusesQueryKey = ReturnType<typeof segmentsGetStationStatusStatusesQueryKey>

export function segmentsGetStationStatusStatusesQueryOptions(params?: SegmentsGetStationStatusStatusesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = segmentsGetStationStatusStatusesQueryKey(params)
        return queryOptions<SegmentsGetStationStatusStatusesQueryResponse, ResponseErrorConfig<SegmentsGetStationStatusStatuses400 | SegmentsGetStationStatusStatuses401 | SegmentsGetStationStatusStatuses403>, SegmentsGetStationStatusStatusesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return segmentsGetStationStatusStatuses(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns status (online/offline) and recent segments info for stations. A station is online if it has recorded a segment in the past threshold seconds. Includes latestAt (ISO string) indicating the most recent segment endTs. If ids query parameter is provided, returns status for those specific stations. If omitted, returns status for stations visible to the authenticated user.
 * @summary Get status for stations
 * {@link /segments/v1/status}
 */
export function useSegmentsGetStationStatusStatuses<TData = SegmentsGetStationStatusStatusesQueryResponse, TQueryData = SegmentsGetStationStatusStatusesQueryResponse, TQueryKey extends QueryKey = SegmentsGetStationStatusStatusesQueryKey>(params?: SegmentsGetStationStatusStatusesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SegmentsGetStationStatusStatusesQueryResponse, ResponseErrorConfig<SegmentsGetStationStatusStatuses400 | SegmentsGetStationStatusStatuses401 | SegmentsGetStationStatusStatuses403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? segmentsGetStationStatusStatusesQueryKey(params)
         

         const query = useQuery({
          ...segmentsGetStationStatusStatusesQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SegmentsGetStationStatusStatuses400 | SegmentsGetStationStatusStatuses401 | SegmentsGetStationStatusStatuses403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}